/* eslint-disable import/no-anonymous-default-export */
import { SET_OVERLAY_MODE } from '../actionConstants';

export default (state = false, action) => {
  switch (action.type) {
    case SET_OVERLAY_MODE:
      return action.payload;
    default:
      return state;
  }
};
